'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp;
// import RaisedButton from 'material-ui/raised-button';
// import { browserHistory } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _surveyValidation = require('./surveyValidation');

var _surveyValidation2 = _interopRequireDefault(_surveyValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { CitiesField } from 'components';
var classNames = require('classnames');

function asyncValidate(data) {
  // TODO: figure out a way to move this to the server. need an instance of ApiClient
  if (!data.email) {
    return _promise2.default.resolve({});
  }
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      var errors = {};
      var valid = true;
      if (~['bobby@gmail.com', 'timmy@microsoft.com'].indexOf(data.email)) {
        errors.email = 'Email address already used';
        valid = false;
      }
      if (valid) {
        resolve();
      } else {
        reject(errors);
      }
    }, 1000);
  });
}

var SearchView = (_dec = (0, _reduxForm.reduxForm)({
  form: 'dictionarySearch',
  fields: ['q', 'email', 'near', 'currentlyEmployed', 'language'],
  validate: _surveyValidation2.default,
  asyncValidate: asyncValidate,
  asyncBlurFields: ['email']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchView, _Component);

  function SearchView(props) {
    (0, _classCallCheck3.default)(this, SearchView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchView.__proto__ || (0, _getPrototypeOf2.default)(SearchView)).call(this, props));

    var val = props.input !== undefined ? props.input.q : '';
    _this.state = {
      value: val
    };
    return _this;
  }

  (0, _createClass3.default)(SearchView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.input) {
        // login
        // console.log("willReceivePro");
        // console.log(nextProps.input);
        this.props.fields.q.value = nextProps.input.q;
        this.props.fields.near.value = nextProps.input.near;
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(err) {
      console.log("handleChange");
      this.state.value = err.target.value;
    }
  }, {
    key: 'handleLocationChange',
    value: function handleLocationChange(err) {
      console.log("handleLocationChange");
      this.state.addr = err.target.value;
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./SearchView.scss');
      var _props = this.props,
          asyncValidating = _props.asyncValidating,
          _props$fields = _props.fields,
          q = _props$fields.q,
          language = _props$fields.language,
          handleSubmit = _props.handleSubmit;


      var renderInput = function renderInput(field, language, label, showAsyncValidating) {
        // console.log("render onchange?");
        // console.log(field);
        // console.log(language);
        // console.log(this.props.input);
        // console.log(this.props.select);
        // console.log('language');
        // console.log(language);
        // if (language.value === undefined) {
        //   language.value = 'en';
        // }
        var formGroup = classNames('form-group' + (field.error && field.touched ? ' has-error' : ''));

        return _react2.default.createElement(
          'div',
          { className: formGroup },
          _react2.default.createElement('div', { className: 'col-sm-2' }),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-8 ' + styles.inputGroup },
            ' ',
            _react2.default.createElement(
              'span',
              null,
              'T\u1EEB \u0111i\u1EC3n '
            ),
            showAsyncValidating && asyncValidating && _react2.default.createElement('i', { className: 'fa fa-cog fa-spin ' + styles.cog
            }),
            ' ',
            _react2.default.createElement(
              'select',
              (0, _extends3.default)({}, language, { value: language.value || 'en' }),
              _react2.default.createElement(
                'option',
                { value: 'en' },
                'English'
              ),
              _react2.default.createElement(
                'option',
                { value: 'fr' },
                'French'
              ),
              _react2.default.createElement(
                'option',
                { value: 'de' },
                'German'
              ),
              _react2.default.createElement(
                'option',
                { value: 'es' },
                'Spanish'
              )
            ),
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: 'form-control', id: field.name }, field)),
            field.error && field.touched && _react2.default.createElement(
              'div',
              { className: 'text-danger' },
              ' ',
              field.error
            )
          ),
          _react2.default.createElement('div', { className: 'col-sm-2' }),
          _react2.default.createElement(
            'div',
            { style: { display: 'none' }, className: 'col-sm-3' },
            _react2.default.createElement(
              'button',
              { className: 'btn btn-success', type: 'submit' },
              _react2.default.createElement('i', { className: 'fa fa-paper-plane' }),
              ' Submit '
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'row' },
              ' ',
              renderInput(q, language, ''),
              ' '
            )
          )
        )
      );
    }
  }]);
  return SearchView;
}(_react.Component), _class2.propTypes = {
  onClick: _react.PropTypes.func,
  input: _react.PropTypes.string,
  onSubmit: _react.PropTypes.func,
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired
}, _temp)) || _class);
exports.default = SearchView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Knowledge/SearchView.js
// module id = 1506
// module chunks = 0